<template>

    <div class="step-content">
        <div class="intro-block">
            <h5 class="txt-grt">Additional services</h5>
            <p>You need more features? Choose advanced options to improve the user experience and engage your community.</p>
        </div>
        <div class="step-inner-content">

            <SelectWrapper item="Recommendation" 
                caption="Provide your subscribers with a customized experience" 
                :price="Global.products.recommendation.price"
                v-model="Global.mockupConfig.services.recommendation"
            ></SelectWrapper>
            <SelectWrapper item="Advanced content protection" 
                caption="Benefit from VPN detection, holywood-grade content encryption"
                :price="Global.products.content_protection.price"
                v-model="Global.mockupConfig.services.content_protection"
            ></SelectWrapper>
            <SelectWrapper item="Content tagging" 
                caption="Add tags to access quickly the key events of your videos" 
                :price="Global.products.content_tagging.price"
                v-model="Global.mockupConfig.services.content_tagging"
            ></SelectWrapper>
            <SelectWrapper item="Rich Metadata & Content enrichment" 
                caption="You want more information about your movies ? Images ? Actors ? We have the IMDb data ready for you" 
                :price="Global.products.content_enrichment.price"
                v-model="Global.mockupConfig.services.content_enrichment"
            ></SelectWrapper>
            
            <div class="nxt-out">
                <div class="bgout"></div>
                <router-link tag="div" to="/look" class="btn bck">
                    <span class="txt">Back</span>
                </router-link>
                <router-link tag="div" to="/payment" class="btn main txt-blk">
                    <span class="hvr"></span>
                    <span class="txt">Continue</span>
                </router-link>
            </div>
        </div>
    </div>

</template>

<script>

    import Global from '../../lib/GlobalState'
    import SelectWrapper from '../../components/SelectWrapper'

    export default {

        name: 'E',

        components: {
            SelectWrapper
        },

        data() {
            return {
                Global
            }
        }
    }
</script>